import React, { useState, useRef, useEffect } from "react";
import { FaUser, FaCog, FaSignOutAlt, FaUserFriends } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Profile = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  // Toggle profile dropdown visibility
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle logout
  const handleLogout = () => {
    // Clear all local storage data
    localStorage.clear();
    sessionStorage.clear();


    navigate("/admin");

    // Optional: Refresh the page to ensure clean state
    window.location.reload();
  };

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Profile Button */}
      <button
        onClick={toggleDropdown}
        className="flex items-center focus:outline-none"
        aria-label="Open Profile Menu"
      >
        <div className="w-7 h-7 mr-2 bg-[--primary-color] text-white rounded-full flex items-center justify-center  text-lg shadow-md  hover:scale-105 transition-transform duration-300 overflow-hidden">
          A
        </div>
      </button>

      {/* Profile Dropdown */}
      {isDropdownOpen && (
        <div className="absolute right-0 mt-3 w-52 bg-white rounded-lg shadow-lg border border-gray-200 z-50 animate-fade-in">
          {/* User Info */}
          <div className="px-4 py-3 text-center border-b">
            <p className="text-sm font-semibold text-[text-color]">Admin</p>

          </div>

          {/* Dropdown Links */}
          <ul className="py-2">


            <li>
              <button
                className="w-full flex items-center px-4 py-2 text-sm text-black hover:bg-gray-100 text-left"
                onClick={() => {
                  navigate("/adduser");
                  setIsDropdownOpen(false);
                }}
              >
                <FaUserFriends className="mr-2  text-[--text-color-g]" /> Add User
              </button>
            </li>
            <li>
              <button
                className="w-full flex items-center px-4 py-2 text-sm text-black hover:bg-gray-100 text-left"
                onClick={handleLogout}
              >
                <FaSignOutAlt className="mr-2 text-red-500" /> Logout
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default Profile;